import React from 'react';
import {
  Box,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';

export const APPROVAL_V2_STEP_STATUS_LABELS = {
  WAITING: '대기',
  PENDING: '처리대기',
  APPROVED: '승인',
  REJECTED: '반려',
  CANCELED: '취소',
  SKIPPED: '생략',
  DELEGATED: '대결',
};

export const APPROVAL_V2_ACTION_TYPE_LABELS = {
  SUBMIT: '상신',
  APPROVE: '승인',
  REJECT: '반려',
  RECALL: '회수',
  CANCEL: '취소',
  SKIP: '생략',
  DELEGATE_APPLY: '대결적용',
  AUTO_APPROVE: '자동승인',
  LINE_CHANGED: '결재선변경',
};

const ApprovalV2HistoryPanel = ({ steps = [], actions = [] }) => {
  return (
    <Stack spacing={3}>
      <Box>
        <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1.5 }}>
          결재 단계
        </Typography>
        <List dense disablePadding>
          {steps.map((step) => (
            <ListItem key={step.apprDocStepId} sx={{ px: 0, alignItems: 'flex-start' }}>
              <ListItemText
                primary={(
                  <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
                    <Typography variant="body2" fontWeight={600}>
                      {step.stepOrder}차 결재
                    </Typography>
                    <Chip
                      label={APPROVAL_V2_STEP_STATUS_LABELS[step.stepStatus] || step.stepStatus}
                      size="small"
                      color={step.stepStatus === 'APPROVED' ? 'success' : step.stepStatus === 'REJECTED' ? 'error' : 'default'}
                      variant={step.stepStatus === 'PENDING' ? 'filled' : 'outlined'}
                    />
                  </Stack>
                )}
                secondary={(
                  <Stack spacing={0.5}>
                    <Typography variant="body2" color="text.secondary">
                      원결재자: {step.originalAssigneeNm || step.originalAssigneeUsrUuid || '-'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      현재 대상자: {step.currentAssigneeNm || step.currentAssigneeUsrUuid || '-'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      처리자: {step.actorUsrNm || '-'}
                      {step.actedAt ? ` / ${dayjs(step.actedAt).format('YYYY-MM-DD HH:mm')}` : ''}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      의견: {step.actionComment || '-'}
                    </Typography>
                  </Stack>
                )}
              />
            </ListItem>
          ))}
          {steps.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              결재 단계 정보가 없습니다.
            </Typography>
          )}
        </List>
      </Box>

      <Divider />

      <Box>
        <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1.5 }}>
          액션 이력
        </Typography>
        <List dense disablePadding>
          {actions.map((action) => (
            <ListItem key={action.actionId} sx={{ px: 0, alignItems: 'flex-start' }}>
              <ListItemText
                primary={(
                  <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5, flexWrap: 'wrap' }}>
                    <Chip
                      label={APPROVAL_V2_ACTION_TYPE_LABELS[action.actionType] || action.actionType}
                      size="small"
                      color={action.actionType === 'APPROVE' ? 'success' : action.actionType === 'REJECT' ? 'error' : 'default'}
                      variant="outlined"
                    />
                    <Typography variant="body2" fontWeight={600}>
                      {action.actorUsrNm || action.actorUsrUuid || '-'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {action.actionAt ? dayjs(action.actionAt).format('YYYY-MM-DD HH:mm') : ''}
                    </Typography>
                  </Stack>
                )}
                secondary={(
                  <Stack spacing={0.5}>
                    <Typography variant="body2" color="text.secondary">
                      의견: {action.actionComment || '-'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      처리구분: {action.onBehalfOfUsrNm ? `${action.onBehalfOfUsrNm} 대결 처리` : '본결재'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      스냅샷: v{action.docSnapshotVer || '-'} / {action.docSnapshotHash || '-'}
                    </Typography>
                  </Stack>
                )}
              />
            </ListItem>
          ))}
          {actions.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              액션 이력이 없습니다.
            </Typography>
          )}
        </List>
      </Box>
    </Stack>
  );
};

export default ApprovalV2HistoryPanel;
